import React from 'react';
import '../About_us/AboutUs.css'
import Footer from '../Footer/footer'
import TeamImage from '../../Assets/team1.jpg'; 
import MissionImage from '../../Assets/mission1.jpg'; 
import Commitment from '../../Assets/Commitment.jpg'
import SpecializationIcon1 from '../../Assets/spn.svg';
import SpecializationIcon2 from '../../Assets/spn.svg'; 
import SpecializationIcon3 from '../../Assets/spn.svg'; 
import Header from '../Header/header';

const specializations = [
  {
    icon: SpecializationIcon1,
    title: 'Talent Acquisition',
    description: 'Specialized in IT/ITES and NON-IT recruitment to help your company grow efficiently.',
  },
  {
    icon: SpecializationIcon2,
    title: 'HR Consulting',
    description: 'Providing customized HR solutions tailored to meet your business needs.',
  },
  {
    icon: SpecializationIcon3,
    title: 'Training & Development',
    description: 'Offering training programs to enhance workforce skills and performance.',
  },
  {
    icon: SpecializationIcon1,
    title: 'Payroll Management',
    description: 'Efficient and reliable payroll management services to streamline operations.',
  },
  {
    icon: SpecializationIcon2,
    title: 'Employee Engagement',
    description: 'Fostering better employee relationships through innovative engagement strategies.',
  },
  {
    icon: SpecializationIcon3,
    title: 'Compliance Management',
    description: 'Ensuring your organization adheres to labor laws and regulatory requirements.',
  },
  {
    icon: SpecializationIcon1,
    title: 'IT Services and Development',
    description: 'Providing exceptional IT services, including development and maintenance of tailor-made software solutions for various business needs.',
  }
];

const AboutUs = () => {
  return (
    <>
      <Header/>

      <div className="about-us">
        <h1>About Us</h1>

        {/* Section 1: Welcome to Shritech */}
        <section className="welcome-section">
          <div className="welcome-content">
            <div className="welcome-text">
              <h3>Welcome To ShriTech- HR Consultancy & IT Service Provider Company</h3>
              <p>Organization totally driven by commitment, honesty, and performance, and committed to client's success.
                Shritech specializes in Talent Acquisition in IT/ITES and NON-IT recruitment and in developing and implementing customize program that enhance your company's efficiency and effectiveness, our mission is to exceed our customer expectation by providing real value and delivering.</p>
            </div>
            <img src={TeamImage} alt="Welcome to Shritech" />
          </div>
        </section>

        {/* Section 2: Our Mission */}
        <section className="mission-section">
          <div className="mission-content">
            <img src={MissionImage} alt="Our Mission" />
            <div className="mission-text">
              <h2>Our Mission</h2>
              <p>The mission of ShriTech is to provide company decisionmakers with high quality, design, implementation and administration of small and mid-size setup practical and usable Human Resources solutions to manage and energize their workforce to achieve the company business goals. This is done by understanding the company business in detail, and their business needs and finally working with decision makers to craft a solution to solve the issue.
                To provide superior, cost effective product and services that meet theever-changing needs of our current and prospective clients, while continuing to strive for the highest professional excellence in delivery of those products and services.
                Achieve excellence while providing services to our clients, Build and maintain long-lasting, consistent, honest and profitable relationship.</p>
              <h4>WE ENSURE</h4>
              <ul>
                <li>High-quality services</li>
                <li>Customer satisfaction</li>
                <li>Innovative solutions</li>
                <li>Continuous improvement</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Section 3: COMMITMENT TO EXCELLENCE */}
        <section className="excellence-section">
          <div className="excellence-content">
            <div className="excellence-text">
              <h2>COMMITMENT TO EXCELLENCE</h2>
              <p>We are committed to delivering excellence in every aspect of our work, ensuring that our clients receive the best possible solutions and services. We believe in partnering with the client and are the basic foundation for our success. We believe in our success, when we exceed our client expectations.
                We believe that honesty and ethical conduct goes long way in making business and personal life fulfilling and successful.
                We always strive and long for personal relationship with clients, and quality services it is our very essence for our continues success. Often our client refers to us as “ Trusted partner ” which we are proud off.</p>
            </div>
            <img src={Commitment} alt="Commitment to Excellence" />
          </div>
        </section>

        {/* Section 4: Our Specialization */}
        <section className="specialization-section">
          <h2>Our Specialization</h2>
          <div className="specialization-cards">
            {specializations.map((specialization, index) => (
              <div className="specialization-card" key={index}>
                <img src={specialization.icon} alt={`${specialization.title} Icon`} />
                <h4>{specialization.title}</h4>
                <p>{specialization.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      <Footer/>
    </>
  );
};

export default AboutUs;
